export default __webpack_public_path__ + "static/media/img-index-04-funcionalidades.0e6d997d.png";